const state = function() {
  return {
    appeals: [],
    typicalAppeals: [],
    paginateData: null,
    isLoaded: false,
    isAdded: false,
    entity: {},
    currentPage: 1
  };
};

export default state;


// WEBPACK FOOTER //
// ./src/modules/appeals/vuex/state.js